import React from "react"
import { Window, View, Text, Video } from "react-ame-components"

export class VideoExample extends React.Component {
  render() {
    return (
      <Window>
        <View margin="extra-small">
          <Text
            fontSize="medium"
            fontWeight="bold">
            Video
          </Text>
          <View
            marginTop="small"
            marginBottom="small">
            <Video
              source={"https://s3.amazonaws.com/calindra.com.br/ame.mp4"}
              controls
              width="160px"
            />
          </View>
          <Text>Um exemplo com thumbnail</Text>
          <View marginTop="quark">
            <Video
              source={"https://s3.amazonaws.com/calindra.com.br/ame.mp4"}
              thumbnail="https://picsum.photos/seed/2/420/270"
              autoPlay
              muted
              width="95%"
            />
          </View>
          <Text>Com a propriedade youtubeId</Text>
          <View marginTop="quark">
            <Video
              youtubeId="rvM1jOX_A9A"
              muted
              autoPlay
              width="95%"
              height={500}
            />
          </View>
        </View>
      </Window>
    )
  }
}
